import { Routes, Route, useNavigate } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import CatalogPage from '../pages/CatalogPage';
import HomePage from '../pages/HomePage';
import ProductDetailPage from '../pages/ProductDetailPage';
import CartPage from '../pages/CartPage';
import FavoritesPage from '../pages/FavoritesPage';
import ProfilePage from '../pages/ProfilePage';
import OrderDetailsPage from '../pages/OrderDetailsPage';
import NotFoundPage from '../pages/NotFoundPage';
import AdminPage from '../pages/AdminPage';
import SyncPage from '../pages/SyncPage';
import ProtectedRoute from './ProtectedRoute';
import DataProcessingPage from '../pages/DataProcessingPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import UserAgreementPage from '../pages/UserAgreementPage';
import CompanyInfoPage from '../pages/CompanyInfoPage';
import RefundPolicyPage from '../pages/RefundPolicyPage';

export default function AppRoutes() {
  const token = localStorage.getItem("token");
  return (
    <Routes>
      <Route path="/auth" element={<LoginPage />} />
      <Route path="/catalog" element={<CatalogPage />} />
      <Route path="/" element={<HomePage />} />
      <Route path="/product/:id" element={<ProductDetailPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/favorites" element={<FavoritesPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/order/:id" element={<OrderDetailsPage />} />
      <Route path="/data-processing" element={<DataProcessingPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/user-agreement" element={<UserAgreementPage />} />
      <Route path="/company-info" element={<CompanyInfoPage />} />
      <Route path="/refund" element={<RefundPolicyPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <AdminPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/sync"
        element={
          <ProtectedRoute adminOnly>
            <SyncPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
